import React from "react";
import {
  Box,
  Paper,
  List,
  ListSubheader,
  ListItem,
  ListItemText,
} from "@mui/material";
import { H9TitleSmall } from "../../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../../components/StyledComponents/Buttons/AuradineButtons.js";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { isEmpty } from "lodash";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";

export const MinersHashing = React.memo((props) => {
  const { minerHashingData } = props;
  const { colors } = useTheme();
  console.log("minerHashingData", minerHashingData);

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        padding="0.25rem 0.5rem 0.25rem 1rem"
        alignItems={"center"}
      >
        <H9TitleSmall> Miners hashing </H9TitleSmall>
      </Box>
      <>
        <List
          sx={{
            width: "100%",
            backgroundColor: colors.background.accent,
            borderRadius: "1.5rem",
          }}
        >
          {!isEmpty(minerHashingData) ? (
            <ListItem>
              <ListItemText
                sx={{ color: colors.text.muted }}
              >
                {
                  minerHashingData?.totalHashingDevicesLastHour
                }
              </ListItemText>
            </ListItem>
          ) : (
            <ListItem>
              <ListItemText 
                secondary="Miners hashing data unavailable"
                sx={{
                  "& .MuiListItemText-secondary": {
                    color: colors.text.muted,
                  },
                }}
              />
            </ListItem>
          )}
        </List>
      </>
    </Box>
  );
});
